import { render, staticRenderFns } from "./SummaryInfoItems.vue?vue&type=template&id=650e6cb2&"
import script from "./SummaryInfoItems.vue?vue&type=script&lang=ts&"
export * from "./SummaryInfoItems.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports